import { CommonMimeType, DocumentInformation } from '@shared/types'
import { setIsExternalNavigation } from '@ui-components/utilities/navigation'

import { base64ToBlob } from '../index'

export const downloadAndOpenBase64 = ({
  base64Encoded,
  documentInformation,
  useDataUrl,
}: {
  base64Encoded: string
  documentInformation: DocumentInformation
  useDataUrl: boolean
}): void => {
  const { mimeType, fileName } = documentInformation
  const linkSource = getBase64LinkSource(base64Encoded, mimeType, useDataUrl)
  openBase64({ linkSource, fileName })
}

export const openBase64 = ({ linkSource, fileName }: { linkSource: string; fileName: string }): void => {
  const downloadLink = document.createElement('a')

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const getBase64LinkSource = (base64Encoded: string, mimeType: CommonMimeType, useDataUrl: boolean): string => {
  let linkSource: string

  if (useDataUrl) {
    linkSource = `data:${mimeType};base64,${base64Encoded}`
  } else {
    const blob = base64ToBlob(base64Encoded, mimeType)
    linkSource = URL.createObjectURL(blob)
  }

  return linkSource
}

export const downloadSignedUrl = (signedUrl: string): void => {
  const link = document.createElement('a')
  link.href = signedUrl
  link.download = ''
  setIsExternalNavigation(true)
  link.click()
  setTimeout(() => {
    setIsExternalNavigation(false)
  }, 500)
}
